'use client';

import { c as _c } from "react/compiler-runtime";
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import type { RefObject } from 'react';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { cn } from '@/lib/ui/utils';
interface OtpFieldProps {
  /** Number of code digits. Matches the backend OTP_LENGTH (6). */
  length?: number;
  value: string;
  onChange: (value: string) => void;
  /** Fires once when the final digit lands — callers auto-submit here. */
  onComplete?: (value: string) => void;
  disabled?: boolean;
  /** Paints destructive borders on every slot (wrong-code state). */
  error?: boolean;
  autoFocus?: boolean;
  /** Focus handle for the hidden input (e.g. refocus after a wrong code). */
  inputRef?: RefObject<HTMLInputElement | null>;
  containerClassName?: string;
  'aria-label'?: string;
}

/**
 * Morfi wrapper around the shadcn `input-otp` primitive — separated digit
 * boxes styled with semantic tokens. Numeric-only, paste distributes across
 * slots, backspace steps back, `autocomplete="one-time-code"` lets iOS/
 * Android suggest the code straight from the email notification.
 */
export function OtpField(t0) {
  const $ = _c(20);
  const {
    length: t1,
    value,
    onChange,
    onComplete,
    disabled,
    error,
    autoFocus,
    inputRef,
    containerClassName,
    "aria-label": ariaLabel
  } = t0;
  const length = t1 === undefined ? 6 : t1;
  let t2;
  if ($[0] !== onComplete) {
    t2 = onComplete !== undefined ? {
      onComplete
    } : {};
    $[0] = onComplete;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = ariaLabel ?? "Verification code";
  let t4;
  if ($[2] !== containerClassName) {
    t4 = cn("justify-center", containerClassName);
    $[2] = containerClassName;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== error || $[5] !== length) {
    let t6;
    if ($[7] !== error) {
      t6 = (_, index) => <InputOTPSlot key={`otp-slot-${String(index)}`} index={index} className={cn("h-12 w-10 rounded-control border bg-background-secondary/90 text-body-lg font-medium text-foreground-primary shadow-none", "first:rounded-control last:rounded-control", "data-[active=true]:border-border-brand data-[active=true]:ring-2 data-[active=true]:ring-border-brand/30", error === true && "border-feedback-error-border")} />;
      $[7] = error;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t5 = <InputOTPGroup className="gap-2">{Array.from({
        length
      }, t6)}</InputOTPGroup>;
    $[4] = error;
    $[5] = length;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[9] !== autoFocus || $[10] !== disabled || $[11] !== inputRef || $[12] !== length || $[13] !== onChange || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== value) {
    t6 = <InputOTP ref={inputRef} maxLength={length} value={value} onChange={onChange} {...t2} pattern={REGEXP_ONLY_DIGITS} inputMode="numeric" autoComplete="one-time-code" autoFocus={autoFocus} disabled={disabled} aria-label={t3} containerClassName={t4}>{t5}</InputOTP>;
    $[9] = autoFocus;
    $[10] = disabled;
    $[11] = inputRef;
    $[12] = length;
    $[13] = onChange;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = value;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}